const patterns: { [key: string]: RegExp } = {
  email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  guid: /^[0-9A-Fa-f]{8}[-]?[0-9A-Fa-f]{4}[-]?[0-9A-Fa-f]{4}[-]?[0-9A-Fa-f]{4}[-]?[0-9A-Fa-f]{12}$/i,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/i,
  fourNumber: /^\d{4}$/,
  fourNumberAndLetters: /^[a-zA-Z0-9]{4}$/,
  fourNumberAndLettersRange: /^[a-zA-Z0-9]{1,4}$/,
  textFiledPinCode: /^\d{1,4}$/,
  notWhiteSpace: /^$/,
  positive: /^[+]?([.]\d+|\d+([.]\d+)?)$/,
  maxFourDigits: /^[0-9a-zA-Z]{1,4}$/,
  exacFourDigits: /^[0-9a-zA-Z]{4}$/,
  priceNumbers: /^[0-9\u0660-\u0669]+(?:\.[0-9\u0660-\u0669]+)?$/,
  quantityNumbers: /^[0-9\u0660-\u0669]+(?:\.[0-9\u0660-\u0669]+)?$/,
  percentageNumber: /^(?![٬,])-?[0-9٠-٩٬,]*(?:\.[0-9٠-٩٬,]+)?(?<!\.)$/,
  intNumber: /^[0-9\u0660-\u0669]+$/,
  floatNumber: /^(?!٬)-?[0-9٠-٩]*(?:\.[0-9٠-٩]+)?(?<!\.)$/,
};

export default patterns;
